export default __webpack_public_path__ + "62439efda699e095e62e3a9b81216638.png";